import { useNavigate } from 'react-router-dom';
import { courses } from '../../../mocks/courses';

export default function CoursesSection() {
  const navigate = useNavigate();

  return (
    <section id="courses" className="py-14 md:py-24 bg-white" data-product-shop>
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        <h2 className="text-[1.6rem] md:text-5xl font-bold text-center text-[#1a2332] mb-10 md:mb-14" style={{ fontFamily: 'Noto Serif KR, serif' }}>
          후니국담의 강좌
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-5">
          {courses.map((course, index) => (
            <div
              key={course.id}
              onClick={() => navigate(`/course/${course.id}`)}
              className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {course.isPopular && (
                <div className="absolute top-4 left-4 z-10">
                  <span className="inline-block px-3 py-1.5 bg-[#1a2332] text-white text-sm rounded-full">
                    인기
                  </span>
                </div>
              )}

              <div className={`relative h-32 md:h-36 flex items-center justify-center ${
                index === 0 ? 'bg-gradient-to-br from-[#4ecdc4]/20 to-[#4ecdc4]/10' :
                index === 1 ? 'bg-gradient-to-br from-[#ff6b6b]/20 to-[#ff6b6b]/10' :
                'bg-gradient-to-br from-[#ffd93d]/20 to-[#ffd93d]/10'
              }`}>
                <i className={`text-5xl md:text-5xl ${
                  index === 0 ? 'ri-medal-line text-[#4ecdc4]' :
                  index === 1 ? 'ri-book-open-line text-[#ff6b6b]' :
                  'ri-draft-line text-[#ffd93d]'
                }`}></i>
              </div>

              <div className="p-5 md:p-6">
                <div className="flex items-center justify-between mb-3 md:mb-3">
                  <span className="px-3 md:px-3 py-1.5 md:py-1.5 bg-[#4ecdc4]/20 text-[#1a2332] text-sm md:text-sm rounded-full font-medium">
                    {course.level}
                  </span>
                  {course.isPopular && (
                    <span className="px-3 md:px-3 py-1.5 md:py-1.5 bg-[#ff6b6b] text-white text-sm md:text-sm rounded-full font-medium">
                      인기
                    </span>
                  )}
                </div>

                <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-3 md:mb-3">
                  {course.name}
                </h3>
                <p className="text-gray-600 text-[14px] md:text-base mb-4 md:mb-4 leading-relaxed whitespace-pre-line line-clamp-2">
                  {course.description}
                </p>

                <div className="space-y-2 md:space-y-2 mb-4 md:mb-4">
                  <div className="flex items-center gap-2 text-[14px] md:text-base text-gray-600">
                    <i className="ri-time-line text-[#ff6b6b]"></i>
                    <span>{course.schedule}</span>
                  </div>
                  <div className="flex items-center gap-2 text-[14px] md:text-base text-gray-600">
                    <i className="ri-group-line text-[#ff6b6b]"></i>
                    <span>정원 {course.capacity}</span>
                  </div>
                </div>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/course/${course.id}`);
                  }}
                  className="w-full py-3 md:py-3 bg-[#f7f7f5] text-[#1a2332] text-[14px] md:text-base rounded-lg font-medium hover:bg-[#1a2332] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  상세 보기
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 bg-[#f7f7f5] rounded-2xl p-7 md:p-8">
          <h3 className="text-lg md:text-2xl font-bold text-[#1a2332] mb-6 md:mb-6 text-center">
            모든 강좌 공통 혜택
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-5">
            <div className="text-center">
              <div className="w-12 h-12 md:w-12 md:h-12 bg-[#4ecdc4]/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-3">
                <i className="ri-file-text-line text-xl md:text-xl text-[#1a2332]"></i>
              </div>
              <p className="text-[14px] md:text-base text-gray-700 font-medium">맞춤 교재 제공</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 md:w-12 md:h-12 bg-[#ff6b6b]/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-3">
                <i className="ri-edit-line text-xl md:text-xl text-[#1a2332]"></i>
              </div>
              <p className="text-[14px] md:text-base text-gray-700 font-medium">1:1 첨삭 지도</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 md:w-12 md:h-12 bg-[#1a2332]/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-3">
                <i className="ri-phone-line text-xl md:text-xl text-[#1a2332]"></i>
              </div>
              <p className="text-[14px] md:text-base text-gray-700 font-medium">학부모 상담</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 md:w-12 md:h-12 bg-[#ffd93d]/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-3">
                <i className="ri-bar-chart-line text-xl md:text-xl text-[#1a2332]"></i>
              </div>
              <p className="text-[14px] md:text-base text-gray-700 font-medium">성적 관리 시스템</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
